import { render, staticRenderFns } from "./newTrashIcon.vue?vue&type=template&id=599088e7"
import script from "./newTrashIcon.vue?vue&type=script&lang=js"
export * from "./newTrashIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports